/* tslint:disable */
import * as React from 'react';
import camelCase from 'lodash/camelCase';

import { ISVGProps } from './common';

const SvgIconLoading: React.FC<ISVGProps> = ({ iconTitle, ...restProps }) => (
  <svg viewBox="0 0 38 38" {...restProps} aria-labelledby={camelCase(iconTitle) ? camelCase(iconTitle) : undefined}>
    <title id={camelCase(iconTitle)}>{iconTitle ? iconTitle : 'Loading'}</title>
    <g fill="none" transform="translate(1, 1)" strokeWidth={0.65}>
      <circle id='loading-circle-outline' className='loading-circle-outline' stroke="#ddd" cx={18} cy={18} r={18} />
      <path id='animation-outline' d="M36 18c0-9.94-8.06-18-18-18" />
    </g>
  </svg>
);

export default SvgIconLoading;
